import { useEffect, useState } from "react";
import useDetailRound from "../rounds/useDetailRound";
import SlimCoupon from "../slimcoupon/slimcoupon";
import { operatorAdviceBetSuccess } from "../App";
import { useFreeBetPurchase } from "../rounds/usePurchase";
import { FreeBet } from "../models/freebet";
import { useHistory } from 'react-router-dom';
import ShowResultOfBet from "../roundview/components/couponform/components/showresultofbet";
import { ErrorResponse } from "../roundview/components/couponform/components/confirmpayment";
import { getSuggestion } from "../common/proPickUtil";
import { Coupon } from "../models/couponshares";
import { trackPurchase } from "../analytics/analytics";


export default function FreeBetCoupon({ roundId, theme, freebet, getProPick, setGetProPick }:
  { roundId: number, theme: string, freebet: FreeBet, getProPick: number, setGetProPick: (counter: number) => void }) {

  const detailedRound = useDetailRound(roundId);
  const [submitting, setSubmitting] = useState(false);
  const [submitFailed, setSubmitFailed] = useState(false);
  const [submitError, setSubmitError] = useState<ErrorResponse | undefined>(undefined);
  const [showConfirm, setShowConfirm] = useState(false);
  const [amount, setAmount] = useState(0);
  const [showResultOfBet, setShowResultOfBet] = useState(false);
  const purchase = useFreeBetPurchase();
  const history = useHistory();
  const [proPickRows, setProPickRows] = useState(undefined);
  let errorResponse: ErrorResponse | undefined;


  useEffect(() => {
    if (getProPick === 0 || detailedRound.round === undefined)
      return;

    getSuggestion({ numHalf: freebet.numHalf, numFull: freebet.numFull }, detailedRound.round.fixtures, setProPickRows);

  }, [getProPick, freebet.numHalf, freebet.numFull, detailedRound.round])


  const onSubmit = async (coupon: Coupon) => {
    setSubmitting(true);

    coupon.freebetId = freebet.id;

    let res: Response = await purchase(coupon) as Response;
    const data = await res.json();
    setSubmitting(false);
    if (res.status === 200) {
      setSubmitFailed(false);
      setSubmitError(undefined);
      //console.log(data);
      if (data && data.transactionId) {
        let betSuccessEvent = {
          type: "bet_success",
          amount: data.amount,
          currency: data.currency,
          transactionId: data.transactionId,
          roundId: data.roundId,
        }
        operatorAdviceBetSuccess(betSuccessEvent);
        setShowConfirm(false);
        setAmount(data.amount);
        setShowResultOfBet(true);
        // Ensure coupon.bets is defined and has at least one element
        const itemCategory2 = (coupon.bets && coupon.bets.length > 0) ? coupon.bets[0].system.type : undefined;

        trackPurchase(data, "freebet", itemCategory2, 1);
      }
      return true;
    } else {
      errorResponse = data
      setSubmitError(errorResponse);
      setSubmitFailed(true);
      return false;
    }
  }

  const handleErrorMessageClose = () => {
    if (submitFailed) {
      setSubmitFailed(false);
      setSubmitError(undefined);
      setShowConfirm(false);
    }
  }

  const onClear = () => {
    setProPickRows(undefined);
    setGetProPick(0);
  }

  if (!detailedRound.round) {
    return <></>;
  }

  return (
    <>

      {showResultOfBet && <ShowResultOfBet toggle={setShowResultOfBet} onClose={() => history.push('/')} />}

      <SlimCoupon coupon={undefined} couponFixtureSummaries={undefined} round={detailedRound.round} onSubmit={onSubmit} theme={window.theme}
        showProPick={false} setShowProPick={() => { }} showConfirm={showConfirm} setShowConfirm={setShowConfirm}
        submitting={submitting} submitFailed={submitFailed} onErrorMsgClose={handleErrorMessageClose} submitError={submitError} stakeMultiplier={1} setStakeMultiplier={() => { }}
        onChangeFixture={() => { }} showRoundInfo={false} setShowRoundInfo={() => { }} showRSystem={false} setShowRSystem={() => { }}
        proPickRows={proPickRows} setProPickRows={() => { }} freebet={freebet} onClear={onClear} setChosenRSystem={() => { }} chosenRSystem={{ type: "MATHEMATICAL" }} />

    </>);

}
